<template>
  <article>
    <TourItem
      class="tour-item--1"
      contentCol="col--lg-7 col--md-10"
      mediaCol="col--lg-5"
      right
    >
      <h1>Hey Jessica Chooses Campsite.bio as her #1 Bio Link Tool</h1>
      <p>Some of the features that Jessica loves:</p>
      <ul style="margin-bottom: 1em">
        <li>⛺️ Pulling in her latest Youtube videos automatically</li>
        <li>
          ⛺️ Scheduling links to go live with a promo or time-sensitive event
        </li>
        <li>⛺️ Complete control of her branding to match her personality</li>
        <li>⛺️ Growing her email list with an opt-in form</li>
      </ul>
      <Button
        href="https://campsite.bio/referral-DP1QOZHV"
        size="large"
        color="secondary"
        variant="hard-shadow"
        >Get Started for Free</Button
      >
      <VText class="tour-btn-text">Get $10 off when you sign up for Pro</VText>

      <div class="tour-item__device-wrapper" slot="media">
        <ScaledDevice class="device" :width="428" :height="868" ref="preview">
          <DeviceIphone>
            <nuxt-img
              src="/campsites/creators/campsite-heyjessica.png"
              :sizes="`xs:500px`"
              :quality="85"
              alt="Campsite.bio profile"
            />
          </DeviceIphone>
        </ScaledDevice>
      </div>
    </TourItem>

    <SeenOn />

    <LargeTextSection
      >Get a best in class link in bio by signing up for the Pro plan. Get $10
      off any plan using the code DP1QOZHV or by clicking any sign-up link on
      this page.</LargeTextSection
    >

    <section class="choicehacking-quote grid grid--container">
      <Rte>
        <img
          src="~/assets/images/landing/review-stars.png"
          alt=" 5/5 stars"
          loading="lazy"
        />
        <h2>The perfect tool even for a picky ex-web designer!</h2>
        <blockquote>
          <p>
            As a very picky ex-web designer, I have always created my own
            landing page on my website to create my link in bio because I felt
            like no platform could offer features or design to make me want to
            use them - UNTIL CAMPSITE.BIO! The ease-of-use, the ability to pull
            in feeds from things like YouTube, and the crazy customizable design
            made using Campsite.bio a no-brainer! Campsite.bio has helped me
            increase clicks to my content, conversions to my email list, and
            sales to my digital products and courses by making is crazy easy for
            my followers to find everything I have to offer.
          </p>
          <cite>- Jessica Stansberry</cite>
        </blockquote>
      </Rte>
    </section>

    <ConfigSection button-url="https://campsite.bio/referral-DP1QOZHV" />
    <ProfilesSection button-url="https://campsite.bio/referral-DP1QOZHV" />
    <ProSection
      button-text="Become a Pro"
      button-url="https://campsite.bio/referral-DP1QOZHV"
    />
  </article>
</template>

<script>
import {
  Button,
  ScaledDevice,
  DeviceIphone,
  VText,
} from '@campsite-bio/component-lib';

import TourItem from '@/components/tour-item';
import SeenOn from '@/components/seen-on-analytics';
import ConfigSection from '@/components/home/config-section/config-section';
import ProfilesSection from '@/components/home/profiles-section/profiles-section';
import ProSection from '@/components/home/pro-section/pro-section';
import Rte from '@/components/rte';
import { useMediaQuery } from '@vueuse/core';
import { generateMeta } from '~/utils/generate-meta';
import LargeTextSection from '@/components/sections/large-text-section';

export default {
  components: {
    Button,
    SeenOn,
    ConfigSection,
    ProfilesSection,
    ProSection,
    TourItem,
    Rte,
    ScaledDevice,
    DeviceIphone,
    VText,
    LargeTextSection,
  },

  head() {
    return generateMeta({
      title: "Hey Jessica's #1 link in bio tool - Campsite.bio",
      description:
        'See why Jessica from Hey Jessica chose Campsite.bio for her link in bio tool. She loves the professional look, the automation features, and the link scheduling.',
    });
  },

  layout: 'landing',

  setup() {
    const isLargerScreen = useMediaQuery('(min-width: 768px)');

    return {
      isLargerScreen,
    };
  },
};
</script>

<style lang="scss" scoped>
.tour-btn-text.tour-btn-text {
  margin-top: 0.75rem;
  font-size: 0.85rem;
}

.device {
  margin: 0 auto;
  width: 250px;
  z-index: 1;

  @media (min-width: 992px) {
    width: 344px;
  }

  &::v-deep {
    img {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;

      &:first-child {
        z-index: 1;
      }
    }
  }
}

.choicehacking-quote {
  padding-top: 3rem;

  > div {
    font-size: 1.25rem;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }

  img {
    margin-bottom: -1.5rem;
  }

  blockquote {
    background: none;
    border-left: none;
    font-size: 1em;

    @media (min-width: 544px) {
      font-size: 1.25em;
    }

    cite {
      color: var(--g-color-on-bg);
      font-style: normal;
      font-size: 1rem;
      font-weight: 600;
    }
  }
}
</style>
